'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_RecipeCalendarPage$State$() {
}
export { $c_Lmealorama_pages_RecipeCalendarPage$State$ as $c_Lmealorama_pages_RecipeCalendarPage$State$ };
$p = $c_Lmealorama_pages_RecipeCalendarPage$State$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_RecipeCalendarPage$State$;
/** @constructor */
function $h_Lmealorama_pages_RecipeCalendarPage$State$() {
}
export { $h_Lmealorama_pages_RecipeCalendarPage$State$ as $h_Lmealorama_pages_RecipeCalendarPage$State$ };
$h_Lmealorama_pages_RecipeCalendarPage$State$.prototype = $p;
$p.m = (function() {
  return "State";
});
$p.aLE = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalDate$().xZ(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Ljava_time_Clock$SystemClock($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_ZoneId$().eT())).IK($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek()), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalDate$().xZ(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Ljava_time_Clock$SystemClock($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_ZoneId$().eT())).IK($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek()).fo(6, 0)));
});
var $d_Lmealorama_pages_RecipeCalendarPage$State$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_RecipeCalendarPage$State$, "mealorama.pages.RecipeCalendarPage$State$", ({
  Ln: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_pages_RecipeCalendarPage$State$ as $d_Lmealorama_pages_RecipeCalendarPage$State$ };
var $n_Lmealorama_pages_RecipeCalendarPage$State$;
function $m_Lmealorama_pages_RecipeCalendarPage$State$() {
  if ((!$n_Lmealorama_pages_RecipeCalendarPage$State$)) {
    $n_Lmealorama_pages_RecipeCalendarPage$State$ = new $c_Lmealorama_pages_RecipeCalendarPage$State$();
  }
  return $n_Lmealorama_pages_RecipeCalendarPage$State$;
}
export { $m_Lmealorama_pages_RecipeCalendarPage$State$ as $m_Lmealorama_pages_RecipeCalendarPage$State$ };
//# sourceMappingURL=mealorama.pages.-Recipe-Calendar-Page$-State$.js.map
